module.exports = __webpack_public_path__ + "static/img/illustrator.8cd996ef.png";